package org.teddapp.project.db.repo

import app.cash.sqldelight.coroutines.asFlow
import app.cash.sqldelight.coroutines.mapToList
import com.tedd.db.Objective_progress_history
import com.tedd.db.TeddDatabase
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.withContext
import org.teddapp.project.db.newId
import org.teddapp.project.db.nowMillis

class ObjectiveProgressHistoryRepository(private val db: TeddDatabase) {

    fun observeByObjective(objectiveId: String): Flow<List<Objective_progress_history>> =
        db.objectiveProgressHistoryQueries
            .selectByObjective(objectiveId)
            .asFlow()
            .mapToList(Dispatchers.Default)

    suspend fun latest(objectiveId: String): Objective_progress_history? = withContext(Dispatchers.Default) {
        db.objectiveProgressHistoryQueries.selectLatestForObjective(objectiveId).executeAsOneOrNull()
    }

    suspend fun append(objectiveId: String, progress: Long, recordedAt: Long = nowMillis()) =
        withContext(Dispatchers.Default) {
            db.objectiveProgressHistoryQueries.insert(
                id = newId("oph"),
                objective_id = objectiveId,
                progress = progress,
                recorded_at = recordedAt,
            )
        }
}
